<template>
  <aside class="aside-filters">
    <button @click="toggleFilters()" class="btn btn--with-icon btn--inverted hidden-desktop open-filter">
      <vs-icon icon="filter_list"/>
      Filtrar
    </button>

    <div class="offer-filters" :class="{'expanded': expanded}">
      <section>
        <div class="hidden-desktop">
          <button @click="toggleFilters()" class="close-filters">
            <vs-icon icon="keyboard_backspace"/>
          </button>
          <h2>
            Filtrar por
          </h2>
        </div>
          <h3 :class="{'hide-title': expanded}">
            Filtrar
          </h3>
         <AuditLogsFastFilter
                        @fastFilterChange="
                            onFastFilterChange($event)
                        "
                    />
        <div v-if="fastFilter === 'users'">
          <div class="input-group">
            <span v-if="organizationId" class="search-select">Entidad</span>
            <model-select :options="organizationsOptions"
              v-model="organizationId"
              placeholder="Entidad">
            </model-select>
          </div>
        
          <div class="input-group">
            <span v-if="filters.userId" class="search-select">Usuario</span>
            <model-select :options="usersOptions"
              v-model="filters.userId"
              placeholder="Usuario">
            </model-select>
          </div>
        </div>
        <div v-if="fastFilter === 'admin'">
          <AdminLogsFilters ref="adminLogsFilters" @adminSelected = "filterAdmin()" />
        </div>
      </section>
        
        

      <section>
        <h3>Fecha</h3>
        <div class="input-group">
          <VueCtkDateTimePicker v-model="filters.createdAt.gte"
                                name="dateStart"
                                label="Fecha/Hora de inicio"
                                color="#01143C"
                                no-button-now
                                locale="es"
                                no-shortcuts
                                format="DD-MM-YYYY HH:mm"
                                :first-day-of-week="7"
                                :class="{error: this.errors.has('filters.dateStart')}"/>
          <span v-if="this.errors.has('filters.dateStart')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            {{ this.errors.first('publishedAt') }}
          </span>
        </div>

        <div class="input-group">
          <VueCtkDateTimePicker v-model="filters.createdAt.lte"
                                name="dateEnd"
                                id="endDatePick"
                                label="Fecha/Hora de fin"
                                color="#01143C"
                                no-button-now
                                locale="es"
                                no-shortcuts
                                format="DD-MM-YYYY HH:mm"
                                :first-day-of-week="7"
                                :class="{error: this.errors.has('filters.dateEnd')}"/>
          <span v-if="this.errors.has('filters.dateEnd')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            {{ this.errors.first('publishedAt') }}
          </span>
        </div>
      </section>
    </div>
  </aside>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapState } from 'vuex'
import AuditLogsFastFilter from "./AuditLogsFastFilter.vue";
import AdminLogsFilters from "./AdminLogsFilters.vue"


const listOrganizations = gql`
  query listOrganizations($currentUserToken: String!, $dashboard: Boolean, $page: Int, $perPage: Int) {
    listOrganizations(currentUserToken: $currentUserToken, dashboard: $dashboard, page: $page, perPage: $perPage) {
      organizations {
        businessName
        cuit
        id
        registrationState
        users {
          email
          firstname
          lastname
          id
        }
      }
    }
  }
`

const retrieveFamilyAttributes = gql`
  query retrieveFamilyAttributes($currentUserToken: String!, $familyAttributes: FamilyAttributesInput!) {
    retrieveFamilyAttributes(currentUserToken: $currentUserToken, familyAttributes: $familyAttributes) {
      id
      name
      organizationId
    }
  }
`

export default {
  components: {
    VueCtkDateTimePicker,
    ModelSelect,
    AuditLogsFastFilter,
    AdminLogsFilters
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    }),
    organizationsOptions () {
      if (this.organizationsList[0]) {
        return this.organizationsList.map(org => {return {text: `${org.businessName} (${org.cuit})`, value: org.id}})
      }
      return []
    },
    usersOptions () {
      if (this.usersList[0]) {
        return this.usersList.map(user => {return {text: `${user.firstname} ${user.lastname}`, value: user.id}})
      }
      return []
    },
  },
  watch: {
    organizationId () {
      this.filters.userId = ''
      if (this.organizationId) {
        this.usersList = this.organizationsList.find(org => org.id == this.organizationId).users
      } else {
        this.usersList = []
      }
    },
    'filters.userId': function () {
      this.filter()
    },
    'filters.createdAt.gte': function () {
      this.filter()
    },
    'filters.createdAt.lte': function () {
      this.filter()
    },
    currentUser () {
      this.filters.createdAt.gte = this.getDate(-30)
      this.filters.createdAt.lte = this.getDate()
    }
  },
  beforeMount () {
    this.getOrganizationsList()
    if (this.currentUser.id) {
      this.filters.createdAt.gte = this.getDate(-30)
      this.filters.createdAt.lte = this.getDate()
    }
  },
  data () {
    return {
      expanded: false,
      organizationsList: [],
      organizationSelector: [],
      organizationId: '',
      usersList: [],
      filters: {
        createdAt: {
          gte: '',
          lte: ''
        },
        userId: '',
      },
      fastFilter: 'users',
    }
  },
  methods: {
    toggleFilters () {
      this.expanded = !this.expanded
    },
    getOrganizationsList () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(listOrganizations),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          perPage: 999999
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.organizationsList = res.data.data.listOrganizations.organizations.filter(e => e.registrationState == 'enabled')
        }
      })
    },
    getDate (plusDays = 0) {
      let date = Date.parse(this.currentUser.currentTime)
      date = new Date(date)
      date.setDate(date.getDate() + plusDays)
      let dateString = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
      return dateString
    },
    filter () {
      if (this.filters.userId) {
        this.$emit('filter')
        this.$emit('reset-list-page')
      }
    },
    //handle changes on fastFilter Component
    onFastFilterChange(event) {
      this.fastFilter = event;
        this.organizationId = '';
        this.usersList = [];
        this.filters = {
          createdAt: {
            gte: this.getDate(-30),
            lte: this.getDate()
          },
          userId: '',
        }  
    },

    //handle admin filters
    filterAdmin() {
      this.filters.userId = this.$refs.adminLogsFilters.adminId;
    }
  }
}
</script>
<style lang="scss" scoped>
  .hide-title {
    display:none;
  }
</style>
